<template>

  <b-sidebar
    id="user-edit-grupos"
    :visible="isEditGruposSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="loadinfo()"
    @change="(val) => $emit('update:is-edit-grupos-sidebar-active', val)"
  >
    <template
      #default="{ hide }"
    >
      <b-overlay
        :show="loader.formulario"
        opacity="0.50"
        rounded="sm"
      >
        <!-- titulo -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            Editar Grupos de Usuario
          </h5>

          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <!-- Formulario -->
        <validation-observer ref="simpleRules">
          <b-form class="mt-1">
            <!-- Grupos -->
            <b-row class="px-3">
              <b-col cols="12">
                <b-card
                  no-body
                  class="mt-1 px-3"
                >
                  <div class="d-flex mt-2 text-primary m-2">
                    <feather-icon
                      icon="UsersIcon"
                      size="19"
                    />
                    <h4 class="mb-0 ml-50 text-primary">
                      Grupos
                    </h4>
                  </div>
                  <b-list-group class="my-2 w-100">
                    <b-list-group-item
                      v-for="(grupos, index) in fmgrupos.grupos"
                      :key="grupos.id_grupo"
                      :variant="grupos.variant"
                    >
                      <b-row>
                        <b-col cols="10">
                          <span
                            :class="`text-${resolveUserGrupoVariant(grupos.grupo)}`"
                            class="align-text-top"
                          > {{ grupos.grupo }}
                          </span>
                        </b-col>
                        <b-col
                          cols="2"
                        >
                          <feather-icon
                            v-if="grupos.grupo != 'Alumno'"
                            class="cursor-pointer"
                            icon="XIcon"
                            size="15"
                            @click="eliminarGrupo(grupos.id_grupo, index)"
                          />
                        </b-col>
                      </b-row>

                    </b-list-group-item>
                  </b-list-group>
                  Agregar Grupo
                  <b-form inline>
                    <b-form-group>
                      <b-form-select
                        v-model="selected"
                        :options="grupoOptions"
                        value-field="nombre"
                        text-field="nombre"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Selecciona --
                          </b-form-select-option>
                        </template>

                      </b-form-select>
                    </b-form-group>

                    <b-button
                      variant="border-trasparent"
                      size="sm"
                      @click.prevent="agregarGrupo()"
                    >
                      <feather-icon
                        icon="PlusCircleIcon"
                        size="24"
                        class="align-middle text-primary"
                      />
                    </b-button>
                  </b-form>
                </b-card>
              </b-col>
            </b-row>
            <b-row class=" p-3">
              <b-col>
                <b-button
                  variant="primary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :disabled="isDisabled"
                  @click.prevent="validationForm()"
                >
                  Guardar
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="hide"
                >
                  Cancelar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BOverlay,
  BForm,
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BListGroup,
  BListGroupItem,
  BFormSelect,
  BFormSelectOption,
} from 'bootstrap-vue'
import { required } from '@validations'
import { getData, postData } from '@core/utils/http/general'
import { ValidationObserver } from 'vee-validate'
import store from '@/store'
import { useUsuariosCatalogos, configTableUsuarios } from '@/views/campus/usuarios/useUsuarios'
import { onMounted } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BForm,
    BButton,
    BRow,
    BCol,
    BOverlay,
    BFormGroup,
    BCard,
    BListGroup,
    BListGroupItem,
    BFormSelect,
    BFormSelectOption,
    BSidebar,
    ValidationObserver,
  },
  model: {
    prop: 'isEditGruposSidebarActive',
    event: 'update:is-edit-grupos-sidebar-active',
  },
  props: {
    isEditGruposSidebarActive: {
      type: Boolean,
      required: true,
    },
    cuentaData: {
      type: Object,
      required: true,
    },
    userData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      selected: null,
      counter: 1,
      loader: {
        formulario: false,
      },
      // FORMS
      fmgrupos: {
        id_usuario: null,
        grupos: [],
      },
      fmdatagrupos: [],
      fmdatapost: {
        elementos: null,
      },
      fmdeliminargrupo: {
        type: Object,
      },
    }
  },
  computed: {
    isDisabled() {
      let respuesta = true
      if (this.fmdatagrupos.length > 0) respuesta = false
      return respuesta
    },
  },
  setup() {
    const toast = useToast()
    const { resolveUserGrupoVariant } = configTableUsuarios()
    const { grupoOptions, grupoOptionsPromise } = useUsuariosCatalogos()
    const fetchCatalogos = () => {
      // loader.value.filters = true
      Promise.all([grupoOptionsPromise])
        .then(() => {
          // loader.value.filters = false
        })
        .catch(error => {
          // loader.value.filters = false
          // errorContent.value.filters = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Catalogos]',
              text: `${error} Descuida, puedes seguir trabajando con la tabla de resultados, nosotros verémos la manera de solucionar el inconveniente ;)`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    onMounted(() => {
      fetchCatalogos() //* Load filter options (selects)
    })
    return {
      grupoOptions,
      grupoOptionsPromise,
      resolveUserGrupoVariant,
    }
    //* Method to load filters, this makes promises, and wait to finish both of them to remove overlay
  },
  methods: {
    loadinfo() {
      this.loader.formulario = true
      getData({ action: 4, token: store.state.cuenta.session.token, id_usuario: this.cuentaData.id_usuario }, 'wsusuarios')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) {
            this.loader.formulario = false
            this.fmgrupos = response.data.data
          } else {
            this.loader.formulario = false
          }
        }).catch(error => {
          this.error_page = true
          this.loader.formulario = false
          this.$bvToast.toast(error, {
            title: 'Error en solicitud',
            variant: 'danger',
            solid: true,
          })
        })
      if (this.grupoOptions[0].nombre === 'Alumno') this.grupoOptions.splice(0, 1)
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitForm()
        }
      })
    },
    submitForm() {
      if (this.counter <= 10) {
        const params = new FormData()
        this.loader.formulario = true
        this.fmdatapost.elementos = this.fmdatagrupos
        params.append('task', 'wsusuarios')
        params.append('origin', process.env.VUE_APP_ORIGIN_API)
        params.append('token', store.state.cuenta.session.token)
        params.append('action', 5)
        params.append('data', JSON.stringify(this.fmdatapost))
        postData(params)
          .then(response => {
            if (response.status === 200 && response.data.status === 200) {
              this.fmgrupos.grupos.forEach((elemento1, index) => {
                this.found = this.userData.find(elemento2 => elemento2.grupo === elemento1.grupo)
                if (this.found === undefined) this.userData.push({ grupo: elemento1.grupo })
                if (elemento1.variant !== undefined) this.fmgrupos.grupos[index].variant = 'primary'
              })
              // this.registroExitoso()
            } else {
              this.$bvToast.toast(response.data.message, {
                title: `${response.data.status} - Error al realizar post`,
                variant: 'danger',
                solid: true,
              })
            }
            this.loader.formulario = false
          })
          .catch(err => {
            this.loader.formulario = false
            this.$bvToast.toast(err, {
              title: 'Error en solicitud',
              variant: 'danger',
              solid: true,
            })
          })
        this.counter += 1
      } else {
        this.$bvToast.toast('La página ha expirado, por favor, intente nuevamente más tarde', {
          title: 'Exceso de intentos',
          variant: 'danger',
          solid: true,
        })
      }
    },
    eliminarGrupo(grupo, index) {
      if (this.counter <= 10) {
        const params = new FormData()
        this.loader.formulario = true
        this.fmdeliminargrupo.usuario = this.cuentaData.id_usuario
        this.fmdeliminargrupo.grupo = grupo
        params.append('task', 'wsusuarios')
        params.append('origin', process.env.VUE_APP_ORIGIN_API)
        params.append('token', store.state.cuenta.session.token)
        params.append('action', 12)
        params.append('data', JSON.stringify(this.fmdeliminargrupo))
        postData(params)
          .then(response => {
            if (response.status === 200 && response.data.status === 200) {
              this.fmgrupos.grupos.splice(index, 1)
              this.userData.splice(index, 1)
              this.registroExitoso()
            } else {
              this.$bvToast.toast(response.data.message, {
                title: `${response.data.status} - Error al realizar post`,
                variant: 'danger',
                solid: true,
              })
            }
            this.loader.formulario = false
          })
          .catch(err => {
            this.loader.formulario = false
            this.$bvToast.toast(err, {
              title: 'Error en solicitud',
              variant: 'danger',
              solid: true,
            })
          })
        this.counter += 1
      } else {
        this.$bvToast.toast('La página ha expirado, por favor, intente nuevamente más tarde', {
          title: 'Exceso de intentos',
          variant: 'danger',
          solid: true,
        })
      }
    },
    registroExitoso() {
      this.$swal({
        title: '<b>Operacion exitosa</b>',
        html: '',
        icon: 'success',
        timer: 10000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    agregarGrupo() {
      this.found = this.fmgrupos.grupos.find(elemento => elemento.grupo === this.selected)
      if (this.found === undefined && this.selected != null) {
        this.fmgrupos.grupos.push({ grupo: this.selected, variant: 'danger' })
        this.grupoOptions.forEach(element => {
          if (element.nombre === this.selected) this.fmdatagrupos.push({ usuario: this.cuentaData.id_usuario, grupo: element.id })
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
